import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconRemoveSvg } from "./IconRemoveSvg.mjs";
const IconRemove = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconRemoveSvg, ...iconProps });
};
export {
  IconRemove
};
